export enum TransactionImportStatusEnum {
  SUCCESSFUL = 'successful',
  IN_PROCESS = 'in_process',
  FAILED = 'failed',
}
